import { Button, Input, Modal, Select } from '@convergence/components';
import Editor from '@monaco-editor/react';
import { Case, Switch } from '../../../Switch';
import { ActionData, FileBrowserSelectionType } from '@convergence/types';
import { useState } from 'react';
import { LabFileBrowser } from '../../../lab-file-browser';
import { useStateLocalStorage } from '../../../../hooks/useStateLocalStorage';

export type PathActionInputType = 'value' | 'code' | 'pattern';

export interface ActionInputSelectorProps {
  actionData: ActionData;
  setActionData: (data: ActionData) => void;
}

const defaultCode = `
# Write your code here to dynamically select a file for your analysis.
"""
    Process a list of lab file paths.
    
    Args:
        paths: A list of strings representing lab file paths.
               Each path should follow the format 'my-lab://some/file/path'.
               Example: ['my-lab://data/input.csv', 'my-lab://models/model.pkl']
    Returns:
        str: A string value based on the input paths.
    """
def getValue(input):
    return "some value here"
`;

export function StringActionInputSelector(props: ActionInputSelectorProps) {
  const [showFileBrowser, setShowFileBrowser] = useState(false);
  const [fileBrowserState, setFileBrowserState] = useStateLocalStorage(
    'fileBrowser',
    {
      path: [] as string[],
      bucketId: null as number | null
    }
  );
  const [showCodeEditor, setShowCodeEditor] = useState(false);
  const value = props.actionData.type === 'value' ? props.actionData.value : '';
  return (
    <div className="flex gap-2 items-center px-2">
      <Switch value={props.actionData.type}>
        <Case value="value">
          <Input
            type="text"
            placeholder="Some value"
            value={value as string}
            onChange={(e) => {
              props.setActionData({
                type: 'value',
                value: e.currentTarget.value
              });
            }}
          />
        </Case>
        <Case value="pattern">
          <Input
            type="text"
            placeholder="*.txt"
            value={value as string}
            onChange={(e) => {
              props.setActionData({
                type: 'pattern',
                pattern: e.currentTarget.value
              });
            }}
          />
        </Case>
        <Case value="code">
          <Button
            onClick={() => {
              setShowCodeEditor(true);
            }}
          >
            Edit
          </Button>
        </Case>
      </Switch>
      <Select
        value={props.actionData.type}
        onChange={(v) => {
          const newType = v.currentTarget.value as ActionData['type'];
          switch (newType) {
            case 'pattern':
              props.setActionData({
                type: 'pattern',
                pattern: ''
              });
              break;
            case 'code':
              props.setActionData({
                type: 'code',
                codeBase64: defaultCode
              });
              break;
            case 'value':
              props.setActionData({
                type: 'value',
                value: ''
              });
              break;
          }
        }}
      >
        <option value="value">Value</option>
        <option value="pattern">Pattern</option>
        <option value="code">Code</option>
      </Select>
      <Modal
        visible={showFileBrowser}
        onClose={() => setShowFileBrowser(false)}
        className=""
      >
        <div className="p-4 h-full overflow-hidden flex flex-col">
          <LabFileBrowser
            path={fileBrowserState.path}
            setPath={(path) =>
              setFileBrowserState({ ...fileBrowserState, path })
            }
            bucketId={fileBrowserState.bucketId ?? undefined}
            setBucketId={(bucketId) =>
              setFileBrowserState({ ...fileBrowserState, bucketId })
            }
            selection={[]}
            pathType={FileBrowserSelectionType.FILE}
            onSelectionChange={(selection) => {
              // if (props.value._regexp) {
              //   const r = new RegExp(props.value._regexp);
              //   const filteredSelection = selection.filter((p) =>
              //     r.test(p.path)
              //   );
              //   props.onChange(props.propertyPath, filteredSelection);
              // } else {
              //   props.onChange(props.propertyPath, selection);
              // }
            }}
          />
          <Button className="mt-4" onClick={() => setShowFileBrowser(false)}>
            Select
          </Button>
        </div>
      </Modal>
      <Modal
        visible={showCodeEditor}
        onClose={() => setShowCodeEditor(false)}
        className=""
      >
        <Editor language="python" defaultValue={defaultCode} />
      </Modal>
    </div>
  );
}
